export enum FOOTER_LINKS {
  LEGAL = 1,
  PRIVACY = 2,
  CMX_WEBSITE = 3,
}
